import React from 'react';
import privacidade from '@/docs/legal/privacidade.md?raw';
import { LegalPage } from './LegalPage';

/** `/privacidade` — Política de privacidade (pública; texto em src/docs/legal/privacidade.md). */
export const PrivacyView: React.FC = () => (
  <LegalPage source={privacidade} sibling={{ to: '/termos', label: 'Termos de uso' }} />
);

export default PrivacyView;
